export function pipeMixins(...mixins) {
  return Object.create(Object.assign({}, ...mixins));
}
